import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { GlobalServices } from './global.service';
import { Languages } from '../models/enums.model';

@Injectable({
  providedIn: 'root'
})
export class MyRequestsService {

  constructor(private http: HttpServices, private global: GlobalServices) { }

  public getMyRequests (requestorId: string, pageIndex: number, pageSize: number, dateFrom: string, dateTo: string, serviceId: string,
                        statusId: string, requestNumber: string ,VesselName: string)
  {
    return this.http.get('BaseRequest/GetByRequestorIdPaged?requestorId=' + requestorId + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
                         + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
                         + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId + '&reqNumber=' + requestNumber+'&VesselName=' + VesselName);
  }
  public getLCMyRequests (requestorId: string, pageIndex: number, pageSize: number, dateFrom: string, dateTo: string, serviceId: string,
    statusId: string, requestNumber: string,VesselName: string)
{
return this.http.get('BaseRequest/GetLCByRequestorIdPaged?requestorId=' + requestorId + '&pageIndex=' + pageIndex + '&pageSize=' + pageSize
     + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
     + '&from=' + dateFrom + '&to=' + dateTo + '&serviceId=' + serviceId + '&statusId=' + statusId + '&reqNumber=' + requestNumber+ '&VesselName=' + VesselName);
}

  public getMyRequestsFilterLookups (userId: string)
  {
    return this.http.get('Lookups/GetMyRequestsLookups?userId=' + userId );
  }
  public getMyRequestsStatusesLookups (serviceId: number)
  {
    return this.http.get('Lookups/GetMyRequestsStatuses?serviceId=' + serviceId );
  }

}
